import { motion } from "framer-motion";
import { BadgePercent, FileText, CalendarCheck } from "lucide-react";

const SUBSIDIES = [
  {
    icon: BadgePercent,
    name: "人材開発支援助成金",
    rate: "最大75%",
    target: "研修プログラム費用",
    description: "DX人材育成研修の受講料・講師料が助成対象。現場主導DX・内製化支援プログラムに適用可能です。",
    applicable: "内製化支援プログラム",
  },
  {
    icon: FileText,
    name: "デジタル化・AI導入補助金",
    rate: "最大2/3",
    target: "システム開発・導入費用",
    description: "AIエージェントの開発費用やクラウド利用料が補助対象。スターターパックやSaaSプランに適用可能です。",
    applicable: "スターターパック / SaaS",
  },
  {
    icon: CalendarCheck,
    name: "IT導入補助金",
    rate: "最大1/2",
    target: "ITツール導入費用",
    description: "業務効率化のためのITツール導入費用が補助対象。クラウド利用料は最大2年間の補助が受けられます。",
    applicable: "全プラン対象",
  },
];

const fadeInUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
};

export function SubsidySection() {
  return (
    <section id="subsidy" className="py-14 sm:py-20 lg:py-28 bg-[#1A1A1A]">
      <div className="container">
        {/* Section Header */}
        <motion.div {...fadeInUp} transition={{ duration: 0.6 }} className="mb-8 sm:mb-16">
          <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
            <div className="w-1.5 sm:w-2 h-7 sm:h-8 bg-[#E03030]" />
            <span className="text-[10px] sm:text-xs font-medium tracking-widest uppercase text-[#666666]" style={{ fontFamily: "'Inter', sans-serif" }}>
              Subsidy
            </span>
          </div>
          <h2 className="text-xl sm:text-2xl lg:text-4xl font-bold text-white mb-3 sm:mb-4">
            補助金・助成金の活用
          </h2>
          <p className="text-sm sm:text-base text-[#AAAAAA] max-w-2xl leading-relaxed">
            すべてのサービスプランで、補助金・助成金の活用を前提に設計しています。制度選定から申請準備、実行管理まで伴走します。
          </p>
        </motion.div>

        {/* Subsidy Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {SUBSIDIES.map((subsidy, i) => (
            <motion.div
              key={subsidy.name}
              {...fadeInUp}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              className="bg-[#222222] border border-[#333333] p-5 sm:p-6 lg:p-8 hover:border-[#E03030] transition-all duration-300"
            >
              <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-[#E03030] text-white rounded-sm mb-4 sm:mb-5">
                <subsidy.icon size={18} strokeWidth={1.5} className="sm:hidden" />
                <subsidy.icon size={20} strokeWidth={1.5} className="hidden sm:block" />
              </div>

              <h3 className="text-sm sm:text-base font-bold text-white mb-2">
                {subsidy.name}
              </h3>

              <div className="flex items-baseline gap-2 mb-3 sm:mb-4">
                <span className="text-2xl sm:text-3xl font-extrabold text-[#E03030]" style={{ fontFamily: "'Inter', sans-serif" }}>
                  {subsidy.rate}
                </span>
                <span className="text-[10px] sm:text-xs text-[#AAAAAA]">{subsidy.target}</span>
              </div>

              <p className="text-xs sm:text-sm text-[#AAAAAA] leading-relaxed mb-3 sm:mb-4">
                {subsidy.description}
              </p>

              <div className="text-[10px] sm:text-xs text-[#666666] border-t border-[#333333] pt-2.5 sm:pt-3">
                対象プラン: <span className="text-[#AAAAAA]">{subsidy.applicable}</span>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Note */}
        <motion.p
          {...fadeInUp}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-6 sm:mt-8 text-[10px] sm:text-xs text-[#666666] max-w-2xl"
        >
          ※ 補助金・助成金の採択は審査によります。適用可能性や補助率は年度・申請時期により変動する場合があります。詳細は無料相談にてご確認ください。
        </motion.p>
      </div>
    </section>
  );
}
